export function mapEmailCredentialsResponseToDto(payload) {
  return {
    fromAddress: String(payload?.fromAddress || '').trim(),
    fromName: payload?.fromName === null || payload?.fromName === undefined ? '' : String(payload.fromName).trim(),
    host: String(payload?.host || '').trim(),
    port: payload?.port === null || payload?.port === undefined ? '' : String(payload.port).trim(),
    username: payload?.username === null || payload?.username === undefined ? '' : String(payload.username).trim(),
    password: String(payload?.password || ''),
  };
}

export function buildEmailCredentialsPayloadFromForm(form) {
  const portValue = String(form?.port || '').trim();

  return {
    fromAddress: String(form?.fromAddress || '').trim(),
    fromName: String(form?.fromName || '').trim() || null,
    host: String(form?.host || '').trim(),
    port: Number(portValue),
    portRaw: portValue,
    username: String(form?.username || '').trim(),
    password: String(form?.password || ''),
  };
}

export function validateEmailCredentialsPayload(payload) {
  const errors = {};

  if (!payload.fromAddress) {
    errors.fromAddress = 'This field is required.';
  }
  if (!payload.host) {
    errors.host = 'This field is required.';
  }
  if (!payload.portRaw) {
    errors.port = 'This field is required.';
  } else if (!Number.isInteger(payload.port) || payload.port <= 0) {
    errors.port = 'Port must be a positive integer.';
  }
  if (!payload.username) {
    errors.username = 'This field is required.';
  }
  if (!payload.password) {
    errors.password = 'This field is required.';
  }

  return errors;
}

export function mapEmailCredentialsFieldErrors(requestError) {
  const errors = {};
  const details = Array.isArray(requestError?.errors) ? requestError.errors : [];

  details.forEach((item) => {
    const parameter = String(item?.parameter || '').trim();
    if (['fromAddress', 'fromName', 'host', 'port', 'username', 'password'].includes(parameter)) {
      errors[parameter] = String(item?.message || 'Invalid value').trim() || 'Invalid value';
    }
  });

  return errors;
}
